import { IPartner } from './partners.models';
import { IIntermediary } from './intermediary.model';

export type SourceOfBusinessType =
  | 'Intermediary'
  | 'Direct'
  | 'Partner'
  | 'SelfService'
  | 'Broker';

export type EndorsementType = 'NewBusiness' | 'Renewal';
export type SourcesOfBusinessPlatform =
  | 'Mobile'
  | 'Web'
  | 'ApiIntegration'
  | 'Ussd'
  | 'AirtelUssd'
  | 'MtnUssd'
  | 'Marketplace';

export const SOURCE_OF_BUSINESS_TYPE_OPTIONS: { value: SourceOfBusinessType; label: string }[] = [
  { value: 'Direct', label: 'Direct' },
  { value: 'Partner', label: 'Partner' },
  { value: 'Intermediary', label: 'Intermediary' },
  { value: 'Broker', label: 'Broker' },
  { value: 'SelfService', label: 'Self Service' },
];

export const SOURCE_OF_BUSINESS_PLATFORM_OPTIONS: { value: SourcesOfBusinessPlatform; label: string }[] = [
  { value: 'Mobile', label: 'Mobile App' },
  { value: 'Web', label: 'Web' },
  { value: 'ApiIntegration', label: 'API Integration' },
  { value: 'Ussd', label: 'USSD' },
  { value: 'AirtelUssd', label: 'Airtel USSD' },
  { value: 'MtnUssd', label: 'MTN USSD' },
  { value: 'Marketplace', label: 'Marketplace' },
];

export interface ISourceOfBusiness {
  intermediaryId: number | null;
  type: SourceOfBusinessType;
  platform: SourcesOfBusinessPlatform;
  intermediary: IIntermediary | null;
  partner: IPartner | null;
  partnerId: number | null;
}

export interface ISourceOfBusinessRequest {
  type: SourceOfBusinessType;
  platform: SourcesOfBusinessPlatform;
  intermediaryId: number | null;
  partnerId: number | null;
}
